export default __webpack_public_path__ + "static/banner-image-85b284c94a4f7c29f5317ff8b2df97c3.jpg";